import type { Section, WrittenPage } from '../../sections'
import { home } from './home'
import { SOLUTIONS_FORM_TR } from '../../solutionsForm'
import { LINKS } from '../links'

/**
 * Çözümler — üç çözümün toplandığı sayfa.
 *
 * İngilizcesinde olduğu gibi ana sayfanın üç kartını yeniden kullanıyor: üç
 * teklifin tek bir tarifi, tek bir yerde. Kartları burada tekrar yazmak, birinin
 * güncellenip diğerinin unutulmasını beklemek olurdu.
 */
const cards = home.sections.find(
  (s): s is Extract<Section, { kind: 'cards' }> => s.kind === 'cards',
)!

// Ana sayfadaki müşteri logosu duvarı; kartlarla aynı gerekçeyle yeniden
// kullanılıyor: tek bir logo listesi, tek bir yerde. `check` notu burada
// düşürülüyor, ana sayfada kalıyor — aynı not iki sayfada görünmesin.
const { check: _logosCheck, ...logoWall } = home.sections.find(
  (s): s is Extract<Section, { kind: 'logos' }> => s.kind === 'logos',
)!

// Ana sayfadaki iki müşteri sözü; kartlar ve logo duvarıyla aynı gerekçeyle
// yeniden kullanılıyor. `variant: 'minimal'`, Hall of Fame kartının sade hâli —
// Transform Better playbook'unun kapanışındaki tasarımın küçük versiyonu;
// 31.08.2026'da böyle istendi ("ufak bir şekilde olsun"). `check` notu burada
// düşürülüyor, ana sayfada kalıyor.
const { check: _quotesCheck, ...quotes } = home.sections.find(
  (s): s is Extract<Section, { kind: 'quotes' }> => s.kind === 'quotes',
)!

export const solutions: WrittenPage = {
  navLabel: 'Çözümler',
  title: 'Çözümler',
  description:
    'Strateji Danışmanlığı, Dönüşüm Yönetimi ve Kurumsal Yapay Zeka Çözümleri. Keşfedin, hayata geçirin, sonuç alın.',
  sections: [
    // 28.08.2026'da istendi: hero'da üstteki etiket, başlık ve alt cümle
    // kalkıyor, sadece üç aşama kalıyor. Aşama adları aşağıdaki kartların
    // başlıklarıyla aynı kelimeler.
    {
      kind: 'hero',
      headline: 'Keşfet. Hayata Geçir. Sonuç Al.',
    },
    // Ana sayfadaki üç kartın aynısı: kickersız, pill butonlu (28.08.2026).
    // Burada başlıklar da kendi sayfalarına link — görünüş birebir aynı,
    // sadece tıklanabilir (28.08.2026). Nesneyi değiştirmemek için spread:
    // ana sayfa aynı kartları kullanıyor ve olduğu gibi kalıyor.
    { ...cards, linkTitles: true },
    // Ana sayfadaki logo duvarının aynısı — 31.08.2026'da ekran görüntüsüyle
    // istendi ("bu kısım solutions sayfasında da olsun"). Üç kartın altında,
    // formun üstünde: teklif → referans → iletişim.
    logoWall,
    // İki müşteri sözü, sade Hall of Fame kartında. Logoların altında, formun
    // üstünde: kimlerle çalıştığımızdan ne söylediklerine.
    quotes,
    // Transform Better e-kitabının kartı; kendi sayfasını kapattığı tasarımın
    // aynısı — 31.08.2026'da o kartın ekran görüntüsüyle istendi ("bu transform
    // better ebook tasarımı aynı şekli ile solutions sayfasında uygun şekilde
    // aşağıda olsun ve butonu sayfasına yönlendirsin". Başlık ve yelpaze gibi
    // dizilmiş kapaklar aynı; tek fark butonun gittiği yer: PDF yerine
    // e-kitabın kendi sayfası, o yüzden etiket de "Raporu indirin" değil.
    // Referansların altında, formun üstünde duruyor.
    {
      kind: 'cta',
      tone: 'card',
      heading:
        'Dijital çağda başarının kapısını aralayın. Rehberinizi şimdi alın ve #transformbetter!',
      ctas: [{ label: 'E-kitabı keşfedin', href: LINKS.transformBetterEbook }],
      photo: {
        src: '/photo/transform-better-ebook-covers.webp',
        alt: 'Yelpaze gibi dizilmiş dört Transform Better e-kitabı; kapakta dağ yolu.',
      },
      photoHref: LINKS.transformBetterEbook,
    },
    // Koyu renkli "Hangisine ihtiyacınız olduğundan emin değil misiniz?" bandı
    // 30.08.2026'da kaldırıldı ("bu siyah kutuya gerek yok"). Butonu zaten
    // sayfanın altındaki iletişim formuna kaydırıyordu; kaybolan bir şey yok.
    // Sayfanın kendi formu; paylaşılan kapanış bandının yerine geçiyor (bkz.
    // `app/Layout.tsx` içindeki `NO_CONTACT_BAND`). Alanlar bandınkilerin
    // aynısı, üstüne 31.08.2026'da istenen "hangi çözüm?" kutucukları: yukarıdaki
    // üç karttan en az biri seçilmeden form gönderilmiyor.
    {
      kind: 'form',
      heading: 'İletişime geçelim!',
      ...SOLUTIONS_FORM_TR,
    },
  ],
}
